import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import { useNavigate } from "react-router-dom";
import TextAreaControl from "../../../Controls/TextAreaControl";
import Button from 'react-bootstrap/Button';
import SelectControl from "../../../Controls/SelectControl"
import DatePickerControl from "../../../Controls/DatePickerControl"
import { toast } from 'react-toastify';

import { 
	GetLocal,
	SetLocal,
	FetchService,
	IsEmptyInput,
	ConvertCharacterDate
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

export default function Index(props) {
    const inputRef = useRef(null);
	const input1Ref = useRef(null);
	const inputSelectRef = useRef(null);
	const inputSelect1Ref = useRef(null);
	const navigate = useNavigate();

	const inpDescriptionRef = useRef(null);
	
    const [value, setValue] = useState(0);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);
	const [getSelectData1, setSelectData1] = useState([]);
	
    useEffect(() => {
		var inputValue = {};		
        FetchService("General/Abstract/ShowAreaAbstractList", inputValue, ShowAreaAbstractListSuccess);		
		FetchService("General/Abstract/ShowBuildingUsageAbstractList", inputValue, ShowBuildingUsageAbstractListSuccess);	
    }, []);

	const ShowAreaAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.AreaInfo);
	}	
	
	const ShowBuildingUsageAbstractListSuccess =(ServiceResult)=>{
		setSelectData1(ServiceResult.BuildingUsageInfo);
	}	
	
	const GetFinancialReport = ()=>{	
	
		if(IsEmptyInput(inputSelectRef))   
			return false;	
	
		if(IsEmptyInput(inputRef))  
			return false;		

		if(IsEmptyInput(input1Ref))  
			return false;			
		
		if(IsEmptyInput(inputSelect1Ref))   
			return false;			
	
        var inputValue = {
			session: GetLocal('EmployeeSession'),
			year: inputRef.current.value,
			area : inputSelectRef.current.value,
			usage: inputSelect1Ref.current.value,	
			minimumTransactionValue: input1Ref.current.value	
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFinancialReport", inputValue, GetFinancialReportSuccess);		
	}
	
	const GetFinancialReportSuccess =(ServiceResult)=>{
		var a = document.createElement("a");
		var data_type = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
		a.href = data_type + ServiceResult;
		a.download = "گزارش_دارایی.xls";
		a.click();
	}	
		
    return (
		<div class="text-center my-4">
			<table dir="rtl" className="col col-sm-12 col-md-6">
				<tbody>				
				<tr>
					<td style={{"width": "10%"}}></td>
					<td style={{"width": "30%"}}>منطقه</td>
					<td style={{"width": "100%"}}>
						<SelectControl data={getSelectData} inputRef={inputSelectRef}/>				
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>		
				<br/>				
				<tr>
					<td style={{"width": "17px"}}></td>
					<td style={{"width": "10px"}}>سال</td>
					<td style={{"width": "50px"}}>
						<TextBoxNumericControl
							required={true}
							maxlength={4}
							inputRef={inputRef}
							placeholder="سال"
						/>							
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>
				<br/>				
				<tr>
					<td style={{"width": "17px"}}></td>
					<td style={{"width": "10px"}}>حداقل ارزش معاملاتی</td>
					<td style={{"width": "50px"}}>
						<TextBoxNumericControl
							required={true}
							maxlength={15}
							inputRef={input1Ref}
							placeholder="ریال"
						/>							
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>				
				<br/>	
				<tr>
					<td style={{"width": "10%"}}></td>
					<td style={{"width": "30%"}}>کاربری اعیان</td>
					<td style={{"width": "100%"}}>
						<SelectControl data={getSelectData1} inputRef={inputSelect1Ref}/>				
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>
				<br/>	
				<tr>
					<td colspan="7" className="text-end">
						<ButtonControl 
							variant="primary float-left w-25 mx-2"
							title="دانلود گزارش"
							onClick={GetFinancialReport}
							icon="fa fa-download"
						/>						
					</td>	
				</tr>	
				</tbody>
			</table>
			
			<hr/>
			{getServiceResult != false && <iframe src={"data:application/pdf;base64,"+getServiceResult} width="100%" height="600"></iframe> }
		</div>
    );
}
